module["exports"] = [
  "Пан",
  "Пані"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/name/prefix.js
// module id = 2817
// module chunks = 2